/**
 * 모델
 * @window w_tb_e037w_03
 * @category 금일업무내역조회
 */

export class TodayWorkModel {
  /**
   * 현장코드
   *
   * **data type** varchar(8)
   */
  actcd: string;

  /**
   * 현장명
   *
   * **data type** varchar(8)
   */
  actnm: string;

  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  custcd: string;

  /**
   * 부서코드
   *
   * **data type** varchar(8)
   */
  divicd: string;

  /**
   * 부서명
   *
   * **data type** varchar(8)
   */
  divinm: string;

  /**
   * 호기코드
   *
   * **data type** varchar(8)
   */
  equpcd: string;

  /**
   * 호기명
   *
   * **data type** varchar(8)
   */
  equpnm: string;

  /**
   * 시작시간
   *
   * **data type** varchar(8)
   */
  frtime: string;

  /**
   * ?
   *
   * **data type** varchar(8)
   */
  frtimeSort: string;

  /**
   * 업무내역
   *
   * **data type** varchar(8)
   */
  overwk: string;

  /**
   * 사원코드
   *
   * **data type** varchar(8)
   */
  perid: string;

  /**
   * 사원명
   *
   * **data type** varchar(8)
   */
  pernm: string;

  /**
   * ?
   *
   * **data type** varchar(8)
   */
  remark: string;

  /**
   * ?
   *
   * **data type** varchar(8)
   */
  rptdate: string;

  /**
   * ?
   *
   * **data type** varchar(8)
   */
  rptnum: string;

  /**
   * 직위코드
   *
   * **data type** varchar(8)
   */
  rspcd: string;

  /**
   * 직위명
   *
   * **data type** varchar(8)
   */
  rspnm: string;

  /**
   * 사업자코드
   *
   * **data type** varchar(8)
   */
  spjangcd: string;

  /**
   * 종료시간
   *
   * **data type** varchar(8)
   */
  totime: string;

  constructor(data: any = {}) {
    this.actcd = data.actcd || '';
    this.actnm = data.actnm || '';
    this.custcd = data.custcd || '';
    this.divicd = data.divicd || '';
    this.divinm = data.divinm || '';
    this.equpcd = data.equpcd || '';
    this.equpnm = data.equpnm || '';
    this.frtime = data.frtime || '';
    this.frtimeSort = data.frtime_sort || '';
    this.overwk = data.overwk || '';
    this.perid = data.perid || '';
    this.pernm = data.pernm || '';
    this.remark = data.remark || '';
    this.rptdate = data.rptdate || '';
    this.rptnum = data.rptnum || '';
    this.rspcd = data.rspcd || '';
    this.rspnm = data.rspnm || '';
    this.spjangcd = data.spjangcd || '';
    this.totime = data.totime || '';
  }
}
